import { makeStyles, tokens } from '@fluentui/react-components';
import type { IField } from '@moko/utils';
import { isFieldReadOnly } from '../fieldReadOnly';
import { useOptionalOtherInfoContext } from '../OtherInfoContext';

const enabledText = {
  color: `${tokens.colorNeutralForeground1} !important`,
  WebkitTextFillColor: `${tokens.colorNeutralForeground1} !important`,
  opacity: '1 !important',
};

export const useReadonlyFieldStyles = makeStyles({
  readOnly: {
    '& .fui-Input, & .fui-Textarea, & .fui-Dropdown, & .fui-Combobox, & .fui-SpinButton, & .fui-Select':
      {
        backgroundColor: 'transparent',
        border: 'none',
        boxShadow: 'none',
        opacity: '1 !important',
      },
    '& .fui-Input::after, & .fui-Textarea::after, & .fui-Dropdown::after, & .fui-Combobox::after':
      {
        display: 'none',
      },
    '& input:not([type="radio"]):not([type="checkbox"]), & textarea, & .fui-Dropdown__button, & .fui-Combobox__input':
      {
        ...enabledText,
        cursor: 'default',
        backgroundColor: 'transparent',
      },
    '& input:not([type="radio"]):not([type="checkbox"])::placeholder, & textarea::placeholder':
      enabledText,
  },
  value: {
    opacity: 0.82,
  },
  empty: {
    minHeight: '32px',
    display: 'flex',
    alignItems: 'center',
    paddingInlineStart: tokens.spacingHorizontalM,
  },
});

export const useFieldReadOnly = (field: IField) => {
  const ctx = useOptionalOtherInfoContext();
  return Boolean(
    ctx?.params.readOnly ||
      ctx?.params.isSaved.current ||
      isFieldReadOnly(field)
  );
};

export const isEmptyFieldValue = (value: unknown) =>
  value == null || (typeof value !== 'boolean' && String(value).trim() === '');
